import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import SearchKeyword from '@lean-body/components/organisms/search/search_keyword';
import { InputSearch } from '@lean-body/components/molecules';
import { ZIndex } from '@lean-body/components/constants';
export const SearchKeywordBox = ({ keywordValue, searchKeywords, searchHistories, submitDisabled, onChangeKeyword, onSelectedKeyword, submit, clear, placeholder, onOpen, }) => {
    const [isFocus, setIsFocus] = React.useState(false);
    const onFocus = () => {
        if (onOpen) {
            onOpen();
            return;
        }
        setIsFocus(true);
    };
    const onCloseRecommendation = () => {
        setIsFocus(false);
    };
    const onClickClear = () => {
        clear();
    };
    const onClickCancel = () => {
        setIsFocus(false);
    };
    const onClickKeyword = (v) => {
        setIsFocus(false);
        onSelectedKeyword(v);
    };
    const onSubmitKeyword = (e) => {
        setIsFocus(false);
        submit(e);
    };
    return (React.createElement(React.Fragment, null,
        isFocus && React.createElement("div", { className: css(styles.overlay), onClick: onClickCancel }),
        React.createElement("div", { className: css(styles.container) },
            React.createElement(InputSearch, { className: css(styles.inputSearch), keywordValue: keywordValue, onChangeKeyword: onChangeKeyword, onClickClear: onClickClear, submitDisabled: submitDisabled, onSubmit: onSubmitKeyword, onFocus: onFocus, onClick: onOpen, placeholder: placeholder, autoFocus: isFocus, "data-test": "inputSearch" }),
            isFocus && (React.createElement("div", { className: css(styles.searchRecommendation), onClick: (e) => e.stopPropagation() },
                React.createElement(SearchKeyword, { title: "\u4EBA\u6C17\u306E\u30AD\u30FC\u30EF\u30FC\u30C9", keywords: searchKeywords, onClickKeyword: onClickKeyword, onClickCancel: onCloseRecommendation }),
                React.createElement(SearchKeyword, { title: "\u691C\u7D22\u5C65\u6B74", keywords: searchHistories, onClickKeyword: onClickKeyword }))))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        margin: '0 auto',
        maxWidth: 800,
    },
    inputSearch: {
        width: '100%',
    },
    overlay: {
        position: 'absolute',
        width: '100vw',
        height: '100%',
        top: -16,
        [MediaBreakPointUp.MD]: {
            top: 0,
            left: -16,
        },
    },
    searchRecommendation: {
        position: 'absolute',
        backgroundColor: Colors.White,
        padding: '8px 16px 32px',
        marginTop: 8,
        borderRadius: 4,
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        zIndex: ZIndex.SearchBox,
        [MediaBreakPointUp.MD]: {
            margin: 0,
            padding: '8px 40px 40px',
            maxWidth: 407,
        },
    },
    keywordTitle: {
        margin: 18,
    },
});
